import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
const VSL_EMBED_URL = 'https://embed.fliki.ai/embed/6aa1bd3e5fd38b4876c6cec3';
export function VslPlayer() {
  const [playerLoaded, setPlayerLoaded] = useState(false);
  const containerRef = useRef<HTMLElement>(null);
  useEffect(() => {
    if (playerLoaded) return;
    const node = containerRef.current;
    if (!node) return;
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        setPlayerLoaded(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.4
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, [playerLoaded]);
  return <motion.figure ref={containerRef} initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.25
  }} transition={{
    duration: 0.7,
    ease: [0.22, 1, 0.36, 1]
  }} className="relative mx-auto mt-8 w-full max-w-[54rem] sm:mt-12" data-id="element-288" data-mp="6be2zoyhjuue">
      <div className="mb-3 flex items-center gap-3" data-id="element-289" data-mp="1pvhabkonlztj">
        <span className="flex items-center gap-2 font-mono text-[10px] font-bold uppercase tracking-[0.18em] text-gold" data-id="element-290" data-mp="1puzcijmcfdji">
          <span aria-hidden="true" className="h-1.5 w-1.5 animate-blip rounded-full bg-signal-pink shadow-[0_0_8px_#ff2f92]" data-id="element-291" data-mp="1b0ufzwom7t5s" />
          Cinta de video · Prueba B
        </span>
        <span aria-hidden="true" className="h-px flex-1 bg-[repeating-linear-gradient(90deg,rgba(255,255,255,0.14)_0_6px,transparent_6px_12px)]" data-id="element-292" data-mp="16wwljza8j6j2" />
        <span className="hidden font-mono text-[9.5px] uppercase tracking-[0.16em] text-white/30 sm:block" data-id="element-293" data-mp="s5w1ex04lo73">
          Reproducción autorizada
        </span>
      </div>

      <div aria-hidden="true" className="absolute inset-x-8 top-16 -z-10 hidden h-40 rounded-full bg-[radial-gradient(ellipse,rgba(212,175,55,0.22),transparent_70%)] blur-3xl sm:block" data-id="element-294" data-mp="j8lm90k6teww" />

      <div className="relative rounded-xl border border-gold/25 bg-panel-raised p-2.5 shadow-[0_26px_60px_rgba(0,0,0,0.6)] sm:p-3" data-id="element-295" data-mp="2px5ikau58vvt">
        <div className="relative w-full overflow-hidden rounded-lg bg-black pt-[56.25%]" data-id="element-296" data-mp="2g5rd7mfih1ur">
          {playerLoaded ? <iframe src={`${VSL_EMBED_URL}?autoplay=1&muted=1`} title="Video de presentación — The Visual Disruption Bible 2.0" loading="lazy" allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowFullScreen className="absolute inset-0 h-full w-full border-0" data-id="element-297" data-mp="2b76nigxvy0kk" /> : <button type="button" onClick={() => setPlayerLoaded(true)} aria-label="Reproducir el video de presentación" className="group absolute inset-0 flex flex-col items-center justify-center gap-4 bg-[radial-gradient(ellipse_at_50%_40%,rgba(212,175,55,0.14),transparent_65%),linear-gradient(180deg,#101014,#07070a)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-298" data-mp="2uv73l1b4r59x">
              <span aria-hidden="true" className="absolute inset-0 bg-[repeating-linear-gradient(0deg,rgba(255,255,255,0.03)_0_1px,transparent_1px_4px)]" data-id="element-299" data-mp="2wp1r7g2n7b0" />
              <span className="relative flex h-14 w-14 items-center justify-center rounded-full border-2 border-gold bg-ink/70 text-gold shadow-[0_0_26px_rgba(212,175,55,0.45)] transition-transform duration-300 group-hover:scale-105 sm:h-16 sm:w-16" data-id="element-300" data-mp="cqphe38zbuxz">
                <Play className="ml-0.5 h-6 w-6 fill-gold sm:h-7 sm:w-7" data-id="element-301" data-mp="qpp0ywhmxjna" />
              </span>
              <span className="relative font-mono text-[10px] uppercase tracking-[0.18em] text-bone sm:text-[11px]" data-id="element-302" data-mp="vmny7nwli6pp">
                Reproducir la cinta
              </span>
              <span className="relative font-mono text-[8.5px] uppercase tracking-[0.16em] text-white/35" data-id="element-303" data-mp="2xeu1oqndbxst">
                Expediente VDB-2026-014 · Sesión informativa
              </span>
            </button>}
        </div>
      </div>

      <figcaption className="mt-3 text-center font-mono text-[9px] uppercase tracking-[0.16em] text-white/35" data-id="element-304" data-mp="1x5aqhj46pyfd">
        Sube el volumen · Duración estimada de la sesión informativa
      </figcaption>
    </motion.figure>;
}